import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { Observable } from 'rxjs';
import { FirestoreRange } from '../interfaces/firestore-range';
import { FirestoreProductsService } from './firestore-products.service';

@Injectable({
  providedIn: 'root'
})

export class ProductRangeService {

  // Pre Firestore values
  private baseImg: string[];
  private baseStamp: string;
  private collection: string[];
  private collectionChild: string[];
  private description: string;
  private products: FirestoreRange[];
  private topImg: string[];

  // Filtered Dababase Values
  private stampArray: any[];

  // Properties for sku
  private baseCost: number;
  private baseFsPos: number;
  private baseType;
  private category: string;
  private categoryChild: string;
  private name: string;
  private overallDepth: number|boolean;
  private overallHeight: number;
  private overallWidth: number|boolean;
  private productId: number;
  private skuCat;
  private skuCatChild;
  private topSquareMeter: number|string;
  private topVariable: boolean;

  public productObject: any[];

  constructor(
    private fsProducts: FirestoreProductsService,
    private ls: LocalStorageService
  ) {}

  public castBaseStamp(products: any[]): void {

    const tempArray = new Array();

    for (let i = 0; i < products.length; i++) {

      const forLoopArray: any[] = [];
      let stampArray: any[];

      console.log(products[i]);

      forLoopArray['name'] = products[i].name;
      forLoopArray['baseImg'] = products[i].baseImg;
      forLoopArray['baseStamp'] = products[i].baseStamp;
      forLoopArray['category'] = products[i].category;
      forLoopArray['categoryChild'] = products[i].categoryChild;
      forLoopArray['collection'] = products[i].collection;
      forLoopArray['collectionChild'] = products[i].collectionChild;
      forLoopArray['description'] = products[i].description;
      forLoopArray['topImg'] = products[i].topImg;

      stampArray = products[i].baseStamp.split('.');

      forLoopArray['skuCat'] = stampArray[0];
      forLoopArray['skuCatChild'] = stampArray[1];
      forLoopArray['productId'] = this.ls.filterInt(stampArray[2]);
      forLoopArray['baseType'] = stampArray[3];
      forLoopArray['overallWidth'] = stampArray[4];
      forLoopArray['overallDepth'] = stampArray[5];
      forLoopArray['overallHeight'] = this.ls.filterInt(stampArray[6]);
      forLoopArray['baseCost'] = this.ls.filterInt(stampArray[7]);
      forLoopArray['topSquareMeter'] = stampArray[8];
      forLoopArray['topVariable'] = stampArray[9];

      tempArray.push(forLoopArray);
    }
    this.productObject = tempArray;
  }

  private getProducts(key: string, value: string) {
    this.fsProducts.filterBy(key, value).subscribe(document => {
      this.products = document;
    });
  }

  private getProductRange() {
    this.fsProducts.getProducts().subscribe(document => {
        this.products = document;
    });
  }

  public productObs(): Observable<object> {
    return new Observable(observer => {
      if (observer !== null || observer !== undefined) {
        console.log(this.productObject);
        observer.next(this.productObject);
      }
    });
  }
}
